// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"348":"group-default","970":"group-component"}[chunkId] || chunkId) + "." + {"23":"9c38ba04","348":"e67d6527","970":"5907c1cc"}[chunkId] + ".js";
};